/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AppMessages } from "src/constants/messages.constant";
import { ItemMenuType } from "src/types/ui.type";
import { ControlPanelIcon } from "../icons.component";

interface MenuSidebarProps {
  menu?: Array<ItemMenuType>,
  isExpanded?: boolean,
  showCollapsible?: boolean,
  onCollapse?: any,
};

const MenuSidebar = ({
  menu,
  isExpanded = false,
  showCollapsible = false,
  onCollapse,
}:MenuSidebarProps) => {
  const [labelCollapsible, setLabelCollapsible] = useState('');

  useEffect(() => {
    setLabelCollapsible(isExpanded ? AppMessages.Navigation.CloseExpand : AppMessages.Navigation.OpenExpand);
  }, [isExpanded]);
  return (
    <div className={`app-sidebar-menu ${isExpanded ? 'app-sidebar-menu--expanded':''}`}>
      {menu?.map(m=>(
        <Link
          to={m.path || '/'}
          className={`${isExpanded ? 'app-sidebar-menu__btn__expanded':''}`}
          title={m.label}
        >
          <button className="app-btn-icon">
            {m.icon}
            {isExpanded && (
              <div className="app-sidebar-menu__label">{m.label}</div>
            )}
          </button>
        </Link>
      ))}
      {showCollapsible && (
        <button
          onClick={()=>onCollapse()}
          className={`app-sidebar-menu__collapsible app-btn-icon ${isExpanded ? 'app-sidebar-menu__btn__expanded app-btn-icon--reverse':''}`}
        >
          <div className="app-btn-icon__container">
            <ControlPanelIcon />
          </div>
          {isExpanded && (
            <div className="app-sidebar-menu__label">{labelCollapsible}</div>
          )}
        </button>
      )}
    </div>
  );
};

export default MenuSidebar;
